import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  optionsList: {
    width: 200,
    maxHeight: 300,
  },
}));
